import { Controller } from "stimulus"
import './component.scss'

class FvMessageModalController extends Controller {
  static targets = ["modal", "backdrop"]

  open(event) {
    event.preventDefault()
    this.modalTarget.style.display = 'flex'
    // フェードイン効果
    requestAnimationFrame(() => {
      this.modalTarget.style.opacity = '0'
      requestAnimationFrame(() => {
        this.modalTarget.style.transition = 'opacity 300ms'
        this.modalTarget.style.opacity = '1'
      })
    })
    document.body.style.overflow = 'hidden'
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    // フェードアウト効果
    this.modalTarget.style.opacity = '0'
    setTimeout(() => {
      this.modalTarget.style.display = 'none'
      this.modalTarget.style.transition = ''
      document.body.style.overflow = ''
    }, 300)
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }
}

// StimulusJSに登録
window.Stimulus.register('fv-message-modal', FvMessageModalController)
